import { List, Map, OrderedMap } from 'immutable';
import { types as userTypes } from '@saucelabs/sl-module-user';

import { STATUS_ACTIVE } from './../team-management/constants';
import * as types from './types';
import { modify } from '../../utils';

const initialState = Map({
  selectedFilters: Map({
    phrase: '',
    roles: List(),
    status: List([STATUS_ACTIVE]),
    teams: List(),
  }),
  users: Map({
    currentPage: 1,
    count: 0,
    results: OrderedMap(),
  }),
  userTableLoading: true,
});

const teamManagementReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.UPDATE_OFFSET:
      return state.setIn(['users', 'currentPage'], payload);
    case types.USERLIST_GET.REQUEST:
      return state.set('userTableLoading', true);
    case types.USERLIST_GET.SUCCESS:
      return state.withMutations((mutable) => {
        let users = OrderedMap();
        payload.results.forEach((user) => {
          users = users.set(user.id, user);
        });
        mutable.setIn(['users', 'count'], payload.count);
        mutable.setIn(['users', 'results'], users);
        mutable.set('userTableLoading', false);
      });
    case types.ROLE_UPDATE.SUCCESS: {
      const path = ['users', 'results', `${payload.id}`];
      const user = state.getIn(path, payload.roles);
      user.roles = [...payload.roles];
      return state.setIn(path, user);
    }
    case types.TEAM_ASSIGNMENT.SUCCESS:
      return state.updateIn(
        ['users', 'results', `${payload.user.id}`],
        (user) => ({ ...user, ...payload.user, teams: payload.user.teams }),
      );
    case types.USER_PATCH.SUCCESS:
      return state.updateIn(
        ['users', 'results', `${payload.id}`],
        (user) => ({ ...user, ...payload }),
      );
    case userTypes.LAST_JOB_LIST_GET.SUCCESS:
      return modify(state, ['users', 'results'], (users) => users.map((user) => ({
        ...user,
        lastJob: (payload[user.username] ?? 0) * 1000,
      })));
    case userTypes.ACTIVITY_LIST_GET.SUCCESS:
      return modify(state, ['users', 'results'], (users) => users.map((user) => ({
        ...user,
        activity: payload[user.username] ?? null,
      })));
    case types.MEMBERSHIP_REMOVE.SUCCESS: {
      const updateFn = (user) => ({
        ...user,
        teams: user.teams.filter((team) => team.id !== payload.team),
      });

      return state.updateIn(['users', 'results', `${payload.user}`], updateFn);
    }
    case types.TOGGLE_FILTER:
      return state.setIn(['selectedFilters', payload.label], payload.value);
    case types.CLEAR_FILTERS:
      return state.set('selectedFilters', initialState.get('selectedFilters'));
    default:
      return state;
  }
};

export default teamManagementReducer;
